import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { memo, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function CacheComponent(_ref) {
  var active = _ref.active,
    cache = _ref.cache,
    children = _ref.children,
    name = _ref.name,
    renderDiv = _ref.renderDiv;
  var _useState = useState(function () {
      var cacheDiv = document.createElement("div");
      cacheDiv.setAttribute("id", name);
      cacheDiv.className = "cache-component " + name + " " + (cache ? "cached" : "no-cache");
      return cacheDiv;
    }),
    _useState2 = _slicedToArray(_useState, 1),
    targetElement = _useState2[0];
  var activatedRef = useRef(false);
  activatedRef.current = activatedRef.current || active;
  useLayoutEffect(function () {
    var containerDiv = renderDiv.current;
    if (active) {
      containerDiv === null || containerDiv === void 0 || containerDiv.appendChild(targetElement);
    } else {
      try {
        if (containerDiv !== null && containerDiv !== void 0 && containerDiv.contains(targetElement)) {
          containerDiv === null || containerDiv === void 0 || containerDiv.removeChild(targetElement);
        }
      } catch (e) {
        console.log(e, "removeChild error");
      }
    }
  }, [active, renderDiv, targetElement, children]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: activatedRef.current && /*#__PURE__*/createPortal(children, targetElement)
  });
}
export default /*#__PURE__*/memo(CacheComponent, function (prevProps, nextProps) {
  return prevProps.active === nextProps.active;
});